import { cn } from '@/lib/utils';

/**
 * Interactive text links without a heavy underline.
 * Affordance: medium weight + color shift on hover/focus (Linear / Notion style).
 */
export const interactiveLinkClassName =
  'rounded-sm font-medium text-foreground transition-colors hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50 focus-visible:ring-offset-2';

/** Same pattern when the link should read as primary by default (actions, “view all”). */
export const interactiveLinkPrimaryClassName =
  'rounded-sm font-medium text-primary transition-colors hover:text-primary/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50 focus-visible:ring-offset-2';

export function interactiveLinkClass(
  options?: { primary?: boolean; className?: string }
): string {
  return cn(
    options?.primary ? interactiveLinkPrimaryClassName : interactiveLinkClassName,
    options?.className
  );
}
